import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './PasswordReset.css';

const PasswordReset = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifyingToken, setVerifyingToken] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [tokenValid, setTokenValid] = useState(false);

  useEffect(() => {
    const tokenFromURL = searchParams.get('token');
    const emailFromURL = searchParams.get('email');
    
    if (tokenFromURL && emailFromURL) {
      setToken(tokenFromURL);
      setEmail(decodeURIComponent(emailFromURL));
      verifyToken(tokenFromURL);
    } else {
      setError('Link inválido ou incompleto.');
      setVerifyingToken(false);
    }
  }, [searchParams]);

  const verifyToken = async (tokenToVerify: string) => {
    try {
      const response = await fetch('/api/password-recovery/verify-token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: tokenToVerify }),
      });

      const data = await response.json();

      if (response.ok) {
        setTokenValid(true);
      } else {
        setError(data.error);
      }
    } catch (error) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setVerifyingToken(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    if (newPassword.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres.');
      return;
    }

    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch('/api/password-recovery/change-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
          novaSenha: newPassword,
          email,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Senha alterada com sucesso! Redirecionando para o login...');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError(data.error);
      }
    } catch (error) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (verifyingToken) {
    return (
      <div className="password-reset-container">
        <div className="password-reset-card">
          <div className="loading">Verificando link...</div>
        </div>
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className="password-reset-container">
        <div className="password-reset-card">
          <div className="logo-container">
            <img src="/logo-fks.png" alt="FKS Logo" className="logo" />
          </div>
          <h2>Link Inválido</h2>
          <div className="error-message">{error}</div>
          <div className="back-to-login">
            <a href="/login">← Voltar ao Login</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="password-reset-container">
      <div className="password-reset-card">
        <div className="logo-container">
          <img src="/logo-fks.png" alt="FKS Logo" className="logo" />
        </div>
        
        <h2>Redefinir Senha</h2>
        <p>Digite sua nova senha para o e-mail: <strong>{email}</strong></p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="newPassword">Nova Senha:</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              placeholder="Mínimo 6 caracteres"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmar Senha:</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              placeholder="Digite a senha novamente"
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <button type="submit" disabled={loading || !newPassword || !confirmPassword}>
            {loading ? 'Alterando...' : 'Alterar Senha'}
          </button>
        </form>

        <div className="back-to-login">
          <a href="/login">← Voltar ao Login</a>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;